module.exports = "/assets/data/9be1bb95aa73d0b9d201b4fc958ba91e-CO12.data.json";